import http from './httpRequest.js'

class RtcPrivateApi {
}

RtcPrivateApi.prototype.call = function (uid, mode, offer, clientCallId, options = {}) {
	return http({
		url: `/webrtc/private/call?uid=${uid}&mode=${mode}&clientCallId=${encodeURIComponent(clientCallId || '')}`,
		method: 'post',
		data: JSON.stringify(offer),
		timeout: options.timeout,
		silent: options.silent,
		headers: {
			'Content-Type': 'application/json; charset=utf-8'
		}
	})
}

RtcPrivateApi.prototype.accept = function (uid, answer) {
	return http({
		url: `/webrtc/private/accept?uid=${uid}`,
		method: 'post',
		data: JSON.stringify(answer),
		headers: {
			'Content-Type': 'application/json; charset=utf-8'
		}
	})
}


RtcPrivateApi.prototype.handup = function (uid) {
	return http({
		url: `/webrtc/private/handup?uid=${uid}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.cancel = function (uid, clientCallId, options = {}) {
	return http({
		url: `/webrtc/private/cancel?uid=${uid}&clientCallId=${encodeURIComponent(clientCallId || '')}`,
		method: 'post',
		timeout: options.timeout,
		silent: options.silent
	})
}

RtcPrivateApi.prototype.reject = function (uid) {
	return http({
		url: `/webrtc/private/reject?uid=${uid}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.failed = function (uid, reason) {
	return http({
		url: `/webrtc/private/failed?uid=${uid}&reason=${reason}`,
		method: 'post'
	})
}

RtcPrivateApi.prototype.sendCandidate = function (uid, candidate) {
	return http({
		url: `/webrtc/private/candidate?uid=${uid}`,
		method: 'post',
		data: JSON.stringify(candidate),
		headers: {
			'Content-Type': 'application/json; charset=utf-8'
		}
	});
}

RtcPrivateApi.prototype.restartOffer = function (uid, offer) {
	return http({
		url: `/webrtc/private/restart/offer?uid=${uid}`,
		method: 'post',
		data: JSON.stringify(offer),
		silent: true,
		headers: {
			'Content-Type': 'application/json; charset=utf-8'
		}
	})
}

RtcPrivateApi.prototype.restartAnswer = function (uid, answer) {
	return http({
		url: `/webrtc/private/restart/answer?uid=${uid}`,
		method: 'post',
		data: JSON.stringify(answer),
		silent: true,
		headers: {
			'Content-Type': 'application/json; charset=utf-8'
		}
	})
}

RtcPrivateApi.prototype.heartbeat = function (uid) {
	return http({
		url: `/webrtc/private/heartbeat?uid=${uid}`,
		method: 'post',
		timeout: 4000,
		silent: true
	})
}

RtcPrivateApi.prototype.ringing = function (inviteSlot, notificationKey) {
	return http({
		url: '/app/native/call/ringing?inviteSlot=' + encodeURIComponent(inviteSlot) +
			'&notificationKey=' + encodeURIComponent(notificationKey),
		method: 'post'
	})
}

export default RtcPrivateApi;
